import BaseService from "./BaseService";
import Admin from "@/types/Admin";
import Repository from "@/types/Repository";
import Organization from "@/types/Organization";

export default class AdminService extends BaseService {
    static async auth(data: { username: string, password: string }) {
        return await this.perform<{ accessToken: string, user: Admin }>({
            method: "POST",
            url: "/admin/admins/auth",
            auth: false,
            body: data
        });
    }

    static async checkToken(token: string | null) {
        if (token === null) throw new Error("Token non presente");
        const rawCredentials = atob(token);
        const [username, password] = rawCredentials.split(":");
        return await this.auth({ username, password });
    }

    static async getAdmins(order: "ASC" | "DESC") {
        return await this.perform<Admin[]>({
            method: "GET",
            url: `/admin/admins?order=${order}`,
            auth: true
        });
    }

    static async createAdmin(data: any) {
        return await this.perform<Admin>({
            method: "POST",
            url: "/admin/admins",
            auth: true,
            body: data
        });
    }

    static async updateAdmin(id: number, data: any) {
        return await this.perform<Admin>({
            method: "PUT",
            url: `/admin/admins/${id}`,
            auth: true,
            body: data
        });
    }

    static async deleteAdmin(id: number) {
        return await this.perform<Admin>({
            method: "DELETE",
            url: `/admin/admins/${id}`,
            auth: true
        });
    }


    static async getRepositories() {
        return await this.perform<Repository[]>({
            method: "GET",
            url: "/admin/repositories",
            auth: true
        });
    }

    static async createRepository(data: any) {
        return await this.perform<Repository>({
            method: "POST",
            url: `/admin/repositories`,
            auth: true,
            body: data
        });
    }

    static async updateRepository(id: number, data: any) {
        return await this.perform<Repository>({
            method: "PUT",
            url: `/admin/repositories/${id}`,
            auth: true,
            body: data
        });
    }

    static async deleteRepository(id: number) {
        return await this.perform<Repository>({
            method: "DELETE",
            url: `/admin/repositories/${id}`,
            auth: true
        });
    }


    static async getOrganizations(order: "ASC" | "DESC" = "ASC", filter: string | null = null) {
        return await this.perform<Organization[]>({
            method: "GET",
            url: `/admin/organizations?order=${order}${filter ? `&filter=${filter}` : ""}`,
            auth: true
        });
    }

    static async createOrganization(data: any) {
        return await this.perform<Organization>({
            method: "POST",
            url: `/admin/organizations`,
            auth: true,
            body: data
        });
    }

    static async updateOrganization(id: string, data: any) {
        return await this.perform<Organization>({
            method: "PUT",
            url: `/admin/organizations/${id}`,
            auth: true,
            body: data
        });
    }

    static async deleteOrganization(id: string) {
        return await this.perform<Organization>({
            method: "DELETE",
            url: `/admin/organizations/${id}`,
            auth: true
        });
    }
}
